import { render } from "./InputMail.vue?vue&type=template&id=31222fae&scoped=true"
import script from "./InputMail.vue?vue&type=script&lang=js"
export * from "./InputMail.vue?vue&type=script&lang=js"

import "./InputMail.vue?vue&type=style&index=0&id=31222fae&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31222fae"]])

export default __exports__